import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApiService } from '../../services/API/api.service';

@Component({
  selector: 'app-counter-cancelled',
  templateUrl: './counter-cancelled.component.html',
  styleUrl: './counter-cancelled.component.css'
})
export class CounterCancelledComponent implements OnInit{
  @Input() createdAtOrder: any = '';
  @Input() id_order: any;
  @Input() id_company!: string;
  @Input() fontSize: any = '';
  @Output() finalizionCounter: EventEmitter<boolean> = new EventEmitter<boolean>();
  counterMin: number = 0;
  counterSec: number = 0;
  intervalId: any;
  dashoffset: number = 10;
  dateServer: string = '';
  start: boolean = false;

  constructor(private apiService: ApiService){}

  ngOnInit(): void {
    this.createdAtOrder = new Date(this.createdAtOrder);
    this.getDateServer();
  }

  startCounter():void {
    const dashArray = 380;

    const targetTime = new Date(this.createdAtOrder);

    // difereça de 8 min desde que o pedido foi criado
    const differential = 8 * 60 * 1000;

    //Total em milesegundos
    const totalMilisegundos = differential

    //Adiciona essa diferença a hora do pedido
    const newDate = new Date(targetTime.getTime() + differential);
    
    // Resgata a hora atual
    const currentTime = new Date(this.dateServer);
    
    // Calcular a diferença
    let diferencaEmMilissegundos = newDate.getTime() - currentTime.getTime();

    // Extrair minutos e segundos da diferença
    const diferencaEmMinutos = Math.floor((diferencaEmMilissegundos % (60 * 60 * 1000)) / (60 * 1000));
    const diferencaEmSegundos = Math.floor((diferencaEmMilissegundos % (60 * 1000)) / 1000);

    if(diferencaEmMinutos >= 0 && diferencaEmSegundos >= 0)
    {
      this.counterMin =  diferencaEmMinutos;
      this.counterSec = diferencaEmSegundos;
    }
    else{
      this.counterMin = 0;
      this.counterSec = 0;
      this.finalizionCounter.emit(true);
    }

    this.start = true;

    this.intervalId = setInterval(() =>{
      if(this.counterMin >= 0)
      {
        if(this.counterSec != 0)
        {
          this.counterSec --
        }
        else if(this.counterSec === 0)
        {
          if(this.counterMin === 0)
          {
            clearInterval(this.intervalId);
            this.finalizionCounter.emit(true);
            this.cancelOrder(this.id_order);
          }
          else{
            this.counterMin --;
            this.counterSec = 59
          }

        }
      }

      diferencaEmMilissegundos = diferencaEmMilissegundos - 1000
      let remainingSeconds = diferencaEmMilissegundos;
    
      const updateCircleProgress = () => {
        const percentage = remainingSeconds / totalMilisegundos;
        const dashoffset = dashArray * (1 - percentage);
        this.dashoffset = dashoffset
      };

      updateCircleProgress();
    }, 1000);

  }

  getDateServer(){
    this.apiService.getHours().subscribe(
      (data) =>{
        this.dateServer = data.date;
        this.startCounter();
      },
      (error) =>{
        console.log(error);
      }
    )
  }

  cancelOrder(id_order: number){
    this.apiService.cancelOrder(id_order, this.id_company).subscribe(
    (data) =>{
    },
    (error) =>{
      console.log(error);
    });
  }
}
